import styles from './Footer.module.css'
import useReveal from '../hooks/useReveal.js'

const OFFICES = [
  { city: 'Auckland', detail: 'Level 4, 22 Fanshawe Street' },
  { city: 'Keri Keri', detail: '14 Cobham Road' },
]

const COLUMNS = [
  {
    heading: 'Company',
    links: ['How it works', 'Why us', 'About', 'Careers'],
  },
  {
    heading: 'Employers',
    links: ['Post a role', 'Pricing', 'Industries we cover'],
  },
  {
    heading: 'Candidates',
    links: ['Browse roles', 'Create a profile', 'Salary guide'],
  },
]

export default function Footer() {
  const [ref, visible] = useReveal(0.15)

  return (
    <footer className={styles.footer} ref={ref}>
      <div className={`container ${styles.top} ${visible ? styles.visible : ''}`}>
        <div className={styles.brandCol}>
          <div className={styles.brand}>
            <img src="/logo.jpg" alt="Virtual Recruiter" className={styles.mark} />
            <span>Virtual Recruiter</span>
          </div>
          <p className={styles.tagline}>Find your next, faster.</p>

          <ul className={styles.offices}>
            {OFFICES.map((o) => (
              <li key={o.city}>
                <span className={styles.city}>{o.city}</span>
                <span className={styles.detail}>{o.detail}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.contactCol}>
          <h3 className={styles.colHeading}>Talk to us</h3>
          <p className={styles.contactName}>Michael Chrichton</p>
          <p className={styles.contactRole}>Client Partnerships</p>
          <a href="tel:+64276655450" className={styles.contactPhone}>
            +64 27-665-5450
          </a>
          <a href="mailto:michael@virtual-recruiter.com" className={styles.contactEmail}>
            michael@virtual-recruiter.com
          </a>
        </div>

        {COLUMNS.map((col) => (
          <div key={col.heading} className={styles.col}>
            <h3 className={styles.colHeading}>{col.heading}</h3>
            <ul className={styles.colList}>
              {col.links.map((l) => (
                <li key={l}><a href="#top">{l}</a></li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className={`container ${styles.bottom}`}>
        <p>© {new Date().getFullYear()} Virtual Recruiter NZ Ltd. All rights reserved.</p>
        <div className={styles.legal}>
          <a href="#top">Privacy</a>
          <a href="#top">Terms</a>
        </div>
      </div>
    </footer>
  )
}
